// extracted by mini-css-extract-plugin
var _1 = "WidgetHeaderContent-moduleWidgetHeaderContent__HxsNs";
var _2 = "WidgetHeaderContent-moduletitle__gcnhJ";
export { _1 as "WidgetHeaderContent", _2 as "title" }
